"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipPayMessages = exports.zipCodeFieldMessages = exports.stateFieldMessages = exports.payPalMessages = exports.nameErrorFieldMessages = exports.inputFormInstruction = exports.fieldsMessages = exports.fieldsErrorMessages = exports.countryFieldMessages = exports.cityFieldMessages = exports.cardNumberFieldMessages = exports.cardExpiryFieldMessages = exports.cardCVVFieldMessages = exports.addressLineTwoFieldMessages = exports.addressLineFieldMessages = void 0;
var _reactIntl = require("react-intl");
var fieldsMessages = (0, _reactIntl.defineMessages)({
  firstNameLabel: {
    id: 'inputField.label.firstName',
    description: 'Label for First name field',
    defaultMessage: 'First name'
  },
  lastNameLabel: {
    id: 'inputField.label.lastName',
    description: 'Label for Last name field',
    defaultMessage: 'Last name'
  },
  emailFieldLabel: {
    id: 'inputField.label.Email',
    description: 'Label for Email field',
    defaultMessage: 'Email'
  },
  phoneNumberFieldLabel: {
    id: 'inputField.label.phoneNumber',
    description: 'Label for Phone number field',
    defaultMessage: 'Phone number'
  },
  firstNamePlaceholder: {
    id: 'inputField.placeholder.firstName',
    description: 'Label for First name field',
    defaultMessage: 'John'
  },
  lastNamePlaceholder: {
    id: 'inputField.placeholder.lastName',
    description: 'Label for First name field',
    defaultMessage: 'Doe'
  },
  emailFieldPlaceholder: {
    id: 'inputField.placeholder.email',
    description: 'Label for First name field',
    defaultMessage: 'john.doe@cashstar.com'
  },
  phoneNumberFieldPlaceholder: {
    id: 'inputField.placeholder.phoneNumber',
    description: 'Label for First name field',
    defaultMessage: 'Enter phone number'
  },
  fullNameLabel: {
    id: 'inputField.label.fullName',
    description: 'Label for Full name field',
    defaultMessage: 'Name on Card'
  },
  fullNamePlaceholder: {
    id: 'inputField.placeholder.fullName',
    description: 'Label for Full name placeholder',
    defaultMessage: 'John Doe'
  },
  saveCardLabel: {
    id: 'inputField.label.saveCardLabel',
    description: 'Label for Save card field',
    defaultMessage: 'Save for later'
  },
  makeAsDefaultLabel: {
    id: 'inputField.label.makeAsDefaultLabel',
    description: 'Label for make as default',
    defaultMessage: 'Mark as default'
  }
});
exports.fieldsMessages = fieldsMessages;
var fieldsErrorMessages = (0, _reactIntl.defineMessages)({
  incompleteField: {
    id: 'inputField.errorMessage.incompleteField',
    description: 'Error message if a required field is kept empty',
    defaultMessage: 'Incomplete field'
  },
  exceedsMaxChracters: {
    id: 'inputField.errorMessage.exceedsMaxCharacters',
    description: 'Error message if any field exceeds maximum characters',
    defaultMessage: 'Exceeds {max} characters'
  },
  invalidEmail: {
    id: 'inputField.errorMessage.pleaseEnterAValidEmailAddress',
    description: 'Error message if email field is invalid',
    defaultMessage: 'Please enter a valid email address'
  },
  invalidPhoneNumber: {
    id: 'inputField.errorMessage.pleaseEnterAValidPhoneNumber',
    description: 'Error message if phone number field is invalid',
    defaultMessage: 'Please enter a valid phone number'
  },
  invalidFirstName: {
    id: 'inputField.errorMessage.pleaseEnterAValidFirstName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid first name'
  },
  invalidLastName: {
    id: 'inputField.errorMessage.pleaseEnterAValidLastName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid last name'
  },
  invalidFullName: {
    id: 'inputField.errorMessage.pleaseEnterAValidFullName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid full name'
  }
});
exports.fieldsErrorMessages = fieldsErrorMessages;
var cardNumberFieldMessages = {
  fieldLabel: {
    id: 'inputField.label.cardNumber',
    description: 'Label for Card number field',
    defaultMessage: 'Card number'
  },
  fieldPlaceholder: {
    id: 'inputField.placeholder.cardNumber',
    description: 'Label for Card number field',
    defaultMessage: 'Card number'
  },
  invalidCardNumber: {
    id: 'inputField.errorMessage.invalidCardNumber',
    description: 'Error message if card number field is invalid',
    defaultMessage: 'Please enter a valid card number'
  },
  cardTypeNotSupported: {
    id: 'inputField.errorMessage.cardTypeNotSupported',
    description: 'Error message if card type is not supported',
    defaultMessage: 'Card Type is not supported'
  }
};
exports.cardNumberFieldMessages = cardNumberFieldMessages;
var cardExpiryFieldMessages = {
  label: {
    id: 'inputField.label.cardExpiry',
    description: 'Label for Card Expiry field',
    defaultMessage: 'Expiry date (MM/YY)'
  },
  placeholder: {
    id: 'inputField.placeholder.cardExpiry',
    description: 'Label for Card Expiry field',
    defaultMessage: 'MM/YY'
  },
  invalidCardExpiry: {
    id: 'inputField.errorMessage.invalidCardExpiry',
    description: 'Error message if card expiry field is invalid',
    defaultMessage: 'Please enter a valid expiry date'
  },
  cardExpired: {
    id: 'inputField.errorMessage.cardExpired',
    description: 'Error message if card is expired',
    defaultMessage: 'Card is expired'
  }
};
exports.cardExpiryFieldMessages = cardExpiryFieldMessages;
var cardCVVFieldMessages = {
  label: {
    id: 'inputField.label.cardCVV',
    description: 'Label for Card CVV field',
    defaultMessage: 'CVV/CVC'
  },
  placeholder: {
    id: 'inputField.placeholder.cardCVV',
    description: 'Label for Card CVV field',
    defaultMessage: '3 or 4 digits security code'
  },
  invalidCardCVV: {
    id: 'inputField.errorMessage.invalidCardCVV',
    description: 'Error message if card cvv field is invalid',
    defaultMessage: 'Please enter a valid CVV or CVC'
  }
};
exports.cardCVVFieldMessages = cardCVVFieldMessages;
var countryFieldMessages = {
  label: {
    id: 'inputField.label.country',
    description: 'Label for country',
    defaultMessage: 'Country'
  },
  placeholder: {
    id: 'inputField.placeholder.country',
    description: 'Label for Country field',
    defaultMessage: 'Select country'
  },
  invalidCountry: {
    id: 'inputField.errorMessage.invalidCountry',
    description: 'Error message if Country field is invalid',
    defaultMessage: 'Please enter a valid country'
  }
};
exports.countryFieldMessages = countryFieldMessages;
var zipCodeFieldMessages = {
  label: {
    id: 'inputField.label.zipcode',
    description: 'Label for zipcode',
    defaultMessage: 'ZIP code'
  },
  placeholder: {
    id: 'inputField.placeholder.zipCode',
    description: 'Label for ZIP Code field',
    defaultMessage: 'ZIP code'
  },
  invalidZipcode: {
    id: 'inputField.errorMessage.invalidZipcode',
    description: 'Error message if ZIP code field is invalid',
    defaultMessage: 'Please enter a valid ZIP code'
  }
};
exports.zipCodeFieldMessages = zipCodeFieldMessages;
var addressLineFieldMessages = {
  label: {
    id: 'inputField.label.addressLine',
    description: 'Label for address line',
    defaultMessage: 'Address line 1'
  },
  placeholder: {
    id: 'inputField.placeholder.addressLine',
    description: 'Label for Address Line field',
    defaultMessage: 'Address line 1'
  },
  invalidAddressLine: {
    id: 'inputField.errorMessage.invalidAddressLine',
    description: 'Error message if Address Line field is invalid',
    defaultMessage: 'Please enter a valid address'
  },
  invalidAddressValue: {
    id: 'inputField.errorMessage.invalidAddressValue',
    description: 'Error message if Address Value field is invalid',
    defaultMessage: 'Please enter a valid address'
  }
};
exports.addressLineFieldMessages = addressLineFieldMessages;
var addressLineTwoFieldMessages = {
  label: {
    id: 'inputField.label.addressLineTwo',
    description: 'Label for address line two',
    defaultMessage: 'Address line 2 (Optional)'
  },
  placeholder: {
    id: 'inputField.placeholder.addressLineTwo',
    description: 'Label for Address Line field two',
    defaultMessage: 'Address line 2 (Optional)'
  },
  invalidAddressLine: {
    id: 'inputField.errorMessage.invalidAddressLineTwo',
    description: 'Error message if Address Line Two field is invalid',
    defaultMessage: 'Please enter a valid address'
  }
};
exports.addressLineTwoFieldMessages = addressLineTwoFieldMessages;
var stateFieldMessages = {
  label: {
    id: 'inputField.label.state',
    description: 'Label for state',
    defaultMessage: 'State'
  },
  placeholder: {
    id: 'inputField.placeholder.state',
    description: 'Label for State field',
    defaultMessage: 'State'
  },
  invalidState: {
    id: 'inputField.errorMessage.invalidState',
    description: 'Error message if State field is invalid',
    defaultMessage: 'Please enter a valid state'
  }
};
exports.stateFieldMessages = stateFieldMessages;
var cityFieldMessages = {
  label: {
    id: 'inputField.label.city',
    description: 'Label for city',
    defaultMessage: 'City'
  },
  placeholder: {
    id: 'inputField.placeholder.city',
    description: 'Label for City field',
    defaultMessage: 'City'
  },
  invalidCity: {
    id: 'inputField.errorMessage.invalidCity',
    description: 'Error message if city field is invalid',
    defaultMessage: 'Please enter a valid city'
  },
  invalidCityValue: {
    id: 'inputField.errorMessage.invalidCityValue',
    description: 'Error message if City Value is invalid',
    defaultMessage: 'Please enter a valid city'
  }
};
exports.cityFieldMessages = cityFieldMessages;
var nameErrorFieldMessages = {
  invalidNameField: {
    id: 'inputField.errorMessage.invalidName',
    description: 'Error message if Name field is invalid',
    defaultMessage: 'Please enter a valid Name'
  }
};
exports.nameErrorFieldMessages = nameErrorFieldMessages;
var payPalMessages = {
  initial: {
    id: 'paymentMethod.paypal.login.initial',
    description: 'PayPal login initial messsage',
    defaultMessage: 'To complete the checkout via PayPal, please login and validate the payment details'
  },
  success: {
    id: 'paymentMethod.paypal.login.success',
    description: 'PayPal login success messsage',
    defaultMessage: 'Validation successful, please complete the checkout'
  }
};
exports.payPalMessages = payPalMessages;
var zipPayMessages = {
  minCartAmount: {
    id: 'paymentMethod.zipPay.minCartAmount',
    description: 'Minimum cart amount message',
    defaultMessage: 'The minimum order value to use Zip is $35'
  },
  additionalCharges: {
    id: 'paymentMethod.zipPay.additionalCharges',
    description: 'Additional charges message',
    defaultMessage: 'An additional merchant fee up to {amount} may apply to your order total to use Zip.'
  }
};
exports.zipPayMessages = zipPayMessages;
var inputFormInstruction = {
  instruction: {
    id: 'inputForm.instruction',
    description: 'Input form instruction',
    defaultMessage: 'All fields are required unless marked optional'
  }
};
exports.inputFormInstruction = inputFormInstruction;